/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

/**
 *  Collection of functions used in Crown communication.
 */
export class CrownCom {
  /**
   * Check the response header of an incoming reply.
   * @param obj the response object to check
   */
  static checkResponseHeader(obj) {
    const ret = obj.header != null && obj.header.status === 0;

    if (ret == null) {
      console.warn('General response error:' + obj.header.message); // tslint:disable-line:no-console
    }

    return ret;
  }
  /**
   * Check the response of an incoming event-register reply.
   * @param obj the response object to check
   */


  static checkFunctionCallResponse(obj) {
    let ret = this.checkResponseHeader(obj);

    if (ret) {
      ret = false;
      const d = obj.data;

      if (d != null) {
        ret = d.success;
      } else {
        console.warn('FunctionCall response error'); // tslint:disable-line:no-console
      }
    }

    return ret;
  }

}
//# sourceMappingURL=CrownCom.js.map